import { Route, Switch } from 'react-router-dom';
import { Blank } from 'src/components/common';
import { useStudentActivityV3 } from 'src/container/student-activityv3';
import { ActivityTodoPage } from './ActivityTodoPage';
import { ActivityV3ListPage } from './ActivityV3ListPage';

export function ActivityV3Page() {
  const { data, isLoading } = useStudentActivityV3();

  return (
    <div>
      {isLoading && <Blank />}
      <Switch>
        <Route path="/student/activity" component={() => <ActivityV3ListPage data={data} />} exact />
        <Route path="/student/activity/todo" component={() => <ActivityTodoPage data={data} />} />
      </Switch>
    </div>
  );
}
